(() => {
  const DEFAULT_CONFIG = {
    numv1: 50,
    numv2: 5,
    numv3: 2,
    numv4: 5,
    numv5: 12,
    numv6: 18,
    numv7: 20,
    numv8: 30,
    numv9: 25,
    numv0: 35,
    numv10: 45,
    numv11: 55,
    numv12: 30,
    numv13: 35,
    numv14: 7,
    numv15: 9,
  };

  const MONTHS = [
    "Jan.",
    "Feb.",
    "Mar.",
    "Apr.",
    "May.",
    "Jun.",
    "Jul.",
    "Aug.",
    "Sep.",
    "Oct.",
    "Nov.",
    "Dec.",
  ];

  const BOLD =
    '<span style="color: #5c5c5c; font-weight: bold;">';

  function loadConfig() {
    const node = document.getElementById("quick-add-inventory-config");
    if (!node) return { ...DEFAULT_CONFIG };

    try {
      return { ...DEFAULT_CONFIG, ...JSON.parse(node.textContent) };
    } catch (error) {
      console.error("Quick add inventory config parse failed:", error);
      return { ...DEFAULT_CONFIG };
    }
  }

  function ordinalSuffix(day) {
    if (day % 10 === 1 && day !== 11) return `${day}st`;
    if (day % 10 === 2 && day !== 12) return `${day}nd`;
    if (day % 10 === 3 && day !== 13) return `${day}rd`;
    return `${day}th`;
  }

  function formatDate(num, extraDays = 0) {
    const currentDate = new Date();
    if (num !== undefined && num !== null && num !== "") {
      currentDate.setDate(currentDate.getDate() + Number(num) + extraDays);
    }

    return `${MONTHS[currentDate.getMonth()]} ${ordinalSuffix(
      currentDate.getDate(),
    )}`;
  }

  function kTime(num) {
    return formatDate(num, 0);
  }

  function kTimeC(num) {
    return formatDate(num, 5);
  }

  function kTime3(num) {
    return formatDate(num, -3);
  }

  function kTimeC3(num) {
    return formatDate(num, 2);
  }

  function normalizeTags(tags = []) {
    if (Array.isArray(tags)) return tags;
    if (typeof tags === "string") {
      return tags
        .split(",")
        .map((tag) => tag.trim())
        .filter(Boolean);
    }
    return [];
  }

  function parseProductTags(tags = []) {
    const flags = {
      knew: "",
      klong: "",
      kplus: "",
      kgs: "",
    };

    normalizeTags(tags).forEach((tag) => {
      if (tag === "New-Trial") flags.knew = "New";
      if (tag === "Long-Term") flags.klong = "Long";
      if (tag === "long-term-plus") flags.kplus = "Plus";
      if (tag === "delay-term") flags.kplus = "Delay";
      if (tag === "Graduation dresses") flags.kgs = "Graduation";
    });

    return flags;
  }

  function pickupExpressMessage(
    pickupStart,
    pickupEnd,
    expressStart,
    expressEnd,
    isCustom,
  ) {
    const pickupFn = isCustom ? kTimeC3 : kTime3;
    const expressFn = isCustom ? kTimeC : kTime;

    return `<p></p><p> In-person pickup estimated by ${BOLD}${pickupFn(
      pickupStart,
    )} – ${pickupFn(pickupEnd)} </span></p><p> Express shipping estimated by ${BOLD}${expressFn(
      expressStart,
    )} – ${expressFn(expressEnd)} </span></p><p></p>`;
  }

  function shipWithinMessage(expressStart, expressEnd, isCustom) {
    const expressFn = isCustom ? kTimeC : kTime;

    return `<p></p><P>Ship within ${BOLD}24 HRS </span>( for U.S. only, excluding holidays. )</P><p> Express shipping estimated by ${BOLD}${expressFn(
      expressStart,
    )} – ${expressFn(expressEnd)} </span></p><p></p>`;
  }

  function buildStockMessage({
    inventoryData,
    variant,
    product,
    colorKey,
    sizeKey,
    config = DEFAULT_CONFIG,
  }) {
    if (!variant || !product) {
      return { html: "", highlighted: false };
    }

    const cfg = { ...DEFAULT_CONFIG, ...config };
    const v1 = Number(cfg.numv1);
    const v2 = Number(cfg.numv2);
    const sku = String(variant.sku || "").toUpperCase();
    const isCustom = Boolean(sku) && sku.endsWith("C");
    const likuiNum = inventoryData?.[colorKey]?.[sizeKey];
    const kcid = likuiNum == 1 ? 1 : 0;
    const tags = parseProductTags(product.tags || []);

    const state = {
      html: "",
      highlighted: false,
    };

    const setMessage = (message, highlighted = false) => {
      state.html = message;
      state.highlighted = highlighted;
    };

    if (isCustom) {
      if (kcid < 1) {
        setMessage(
          pickupExpressMessage(
            cfg.numv5,
            cfg.numv6,
            cfg.numv5,
            cfg.numv6,
            true,
          ),
        );
      }

      if (tags.kplus === "Delay") {
        setMessage(
          pickupExpressMessage(
            cfg.numv12,
            cfg.numv13,
            cfg.numv12,
            cfg.numv13,
            true,
          ),
        );
      }

      if (tags.kplus === "Plus") {
        setMessage(
          pickupExpressMessage(
            cfg.numv10,
            cfg.numv11,
            cfg.numv10,
            cfg.numv11,
            true,
          ),
        );
      }

      if (tags.knew === "New") {
        setMessage(
          pickupExpressMessage(
            cfg.numv9,
            cfg.numv0,
            cfg.numv9,
            cfg.numv0,
            true,
          ),
        );
      }

      if (tags.klong === "Long") {
        setMessage(
          pickupExpressMessage(
            cfg.numv7,
            cfg.numv8,
            cfg.numv7,
            cfg.numv8,
            true,
          ),
        );
      }

      if (tags.kgs === "Graduation") {
        setMessage(
          pickupExpressMessage(
            cfg.numv14,
            cfg.numv15,
            cfg.numv14,
            cfg.numv15,
            true,
          ),
        );
      }

      if (kcid > 100) {
        setMessage(shipWithinMessage(cfg.numv3, cfg.numv4, true), true);
      } else if (kcid > v1 && kcid <= 100) {
        setMessage(shipWithinMessage(cfg.numv3, cfg.numv4, true));
      }

      if (kcid <= v1 && kcid >= v2) {
        setMessage(shipWithinMessage(cfg.numv3, cfg.numv4, true), true);
      }

      if (kcid < v2 && kcid > 0) {
        setMessage(shipWithinMessage(cfg.numv3, cfg.numv4, true));
      }
    } else {
      if (kcid < 1) {
        setMessage(
          pickupExpressMessage(
            cfg.numv5,
            cfg.numv6,
            cfg.numv5,
            cfg.numv6,
            false,
          ),
        );
      }

      if (tags.kplus === "Delay") {
        setMessage(
          pickupExpressMessage(
            cfg.numv12,
            cfg.numv13,
            cfg.numv12,
            cfg.numv13,
            false,
          ),
          true,
        );
      }

      if (tags.kplus === "Plus") {
        setMessage(
          pickupExpressMessage(
            cfg.numv10,
            cfg.numv11,
            cfg.numv10,
            cfg.numv11,
            false,
          ),
        );
      }

      if (tags.knew === "New") {
        setMessage(
          pickupExpressMessage(
            cfg.numv9,
            cfg.numv0,
            cfg.numv9,
            cfg.numv0,
            false,
          ),
        );
      }

      if (tags.klong === "Long") {
        setMessage(
          pickupExpressMessage(
            cfg.numv7,
            cfg.numv8,
            cfg.numv7,
            cfg.numv8,
            false,
          ),
        );
      }

      if (tags.kgs === "Graduation") {
        setMessage(
          pickupExpressMessage(
            cfg.numv14,
            cfg.numv15,
            cfg.numv14,
            cfg.numv15,
            false,
          ),
        );
      }

      if (kcid > 100) {
        setMessage(shipWithinMessage(cfg.numv3, cfg.numv4, false));
      } else if (kcid > v1 && kcid <= 100) {
        setMessage(shipWithinMessage(cfg.numv3, cfg.numv4, false));
      }

      if (kcid <= v1 && kcid >= v2) {
        setMessage(shipWithinMessage(cfg.numv3, cfg.numv4, false), true);
      }

      if (kcid < v2 && kcid > 0) {
        setMessage(shipWithinMessage(cfg.numv3, cfg.numv4, false));
      }
    }

    return {
      html: state.html.trim(),
      highlighted: state.highlighted,
    };
  }

  window.QuickAddInventory = {
    loadConfig,
    buildStockMessage,
  };
})();
